import { createDecorator } from '../../instantiation/common/instantiation.js';
const IOpenerService = ( createDecorator('openerService'));
export { IOpenerService };
